import { render, staticRenderFns } from "./modal-scheduler.vue?vue&type=template&id=0664a7b7"
import script from "./modal-scheduler.vue?vue&type=script&lang=js"
export * from "./modal-scheduler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports